import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { postDeclarationDeserted } from '../../services/purchaseOrder'
import { onGetQuoteSummaryThunk } from '../QuoteBasicInformation/QuoteBasicInformation.actions'

export const SHOW_DECLARATION_DESERTED_QUOTE_DIALOG = 'SHOW_DECLARATION_DESERTED_QUOTE_DIALOG'
export const onShowDeclarationDesertedQuoteDialog = makeActionCreator(SHOW_DECLARATION_DESERTED_QUOTE_DIALOG, 'payload')

export const CLOSE_DECLARATION_DESERTED_QUOTE_DIALOG = 'CLOSE_DECLARATION_DESERTED_QUOTE_DIALOG'
export const onCloseDeclarationDesertedQuoteDialog = makeActionCreator(CLOSE_DECLARATION_DESERTED_QUOTE_DIALOG)

export const DECLARATION_ARDESERTED = 'DECLARATION_ARDESERTED'
export const DECLARATION_ARDESERTED_SUCCESS = 'DECLARATION_ARDESERTED_SUCCESS'
export const DECLARATION_ARDESERTED_ERROR = 'DECLARATION_ARDESERTED_ERROR'
export const onDeclaretionDeserted = makeActionCreator(DECLARATION_ARDESERTED)
export const onDeclaretionDesertedError = makeActionCreator(DECLARATION_ARDESERTED_ERROR, 'payload')
export const onDeclaretionDesertedSuccess = makeActionCreator(DECLARATION_ARDESERTED_SUCCESS, 'payload')
export const onDeclaretionDesertedThunk = payload => async dispatch => {
  dispatch(onDeclaretionDeserted())
  try {
    await postDeclarationDeserted(payload)
    batch(() => {
      dispatch(onCloseDeclarationDesertedQuoteDialog())
      dispatch(onGetQuoteSummaryThunk({ quoteId: payload.quoteId }))
    })
  } catch (error) {
    dispatch(onDeclaretionDesertedError({ error: {} }))
  }
}
